export default __webpack_public_path__ + "static/media/No44Open.ab708453.jpg";